import { gameConfig } from '../../../config'
import { GameInfoResponse } from './GameInfoResponse'
import { apiClient } from '@slot-nx/core'
export declare interface IGameInfoApi {
  getGameInfo(): Promise<GameInfoResponse>
}

export const gameInfoApi: IGameInfoApi = {
  async getGameInfo(): Promise<GameInfoResponse> {
    const response = await apiClient.post<GameInfoResponse>(`${gameConfig.name}/GameInfo`)
    return response.data
  },
}

export const mockGameInfoApi: IGameInfoApi = {
  async getGameInfo(): Promise<GameInfoResponse> {
    return {
      eventInfo: {
        isOngoing: false,
        isIconOpen: false,
        promotionId: 72,
      },
      player: {
        playerId: '123',
        playerName: 'Player',
        currency: 'USD',
        balance: 100000,
        language: 'en',
      },
      game: {
        baseFreeSpinCount: 10,
        bonusFreeSpinCount: 5,
        buyBonusInfo: {
          freeGameOdds: 60,
          superFreeGameOdds: 120,
        },
        chipSet: [0.2,
          0.4,
          0.6,
          0.8,
          1.0,
          1.6,
          2.0,
          2.4,
          3.0,
          3.6,
          4.0,
          6.0,
          10.0,
          16.0,
          20.0,
          10000,
        ],
        defaultChipValue: 10000,
        multiplierReelInfo: {
          intervalValue: 5,
          startMultiplier: 5,
        },
        payTable: {
          M1: {
            12: 3,
            10: 1.5,
            8: 0.6,
          },
          M2: {
            12: 2,
            10: 1,
            8: 0.5,
          },
          M3: {
            12: 1.5,
            10: 0.8,
            8: 0.4,
          },
          M4: {
            12: 1.2,
            10: 0.7,
            8: 0.35,
          },
          M5: {
            12: 1,
            10: 0.6,
            8: 0.3,
          },
          A: {
            12: 0.8,
            10: 0.5,
            8: 0.25,
          },
          K: {
            12: 0.7,
            10: 0.4,
            8: 0.2,
          },
          Q: {
            12: 0.5,
            10: 0.3,
            8: 0.15,
          },
          J: {
            12: 0.4,
            10: 0.2,
            8: 0.1,
          },
        },
        slotTable: [
          [
            {
              symbol: 5,
              multiplier: 0,
            },
            {
              symbol: 4,
              multiplier: 0,
            },
            {
              symbol: 3,
              multiplier: 0,
            },
            {
              symbol: 6,
              multiplier: 0,
            },
            {
              symbol: 5,
              multiplier: 0,
            },
          ],
          [
            {
              symbol: 11,
              multiplier: 0,
            },
            {
              symbol: 0,
              multiplier: 0,
            },
            {
              symbol: 7,
              multiplier: 0,
            },
            {
              symbol: 8,
              multiplier: 0,
            },
            {
              symbol: 7,
              multiplier: 0,
            },
          ],
          [
            {
              symbol: 7,
              multiplier: 0,
            },
            {
              symbol: 4,
              multiplier: 0,
            },
            {
              symbol: 3,
              multiplier: 0,
            },
            {
              symbol: 6,
              multiplier: 0,
            },
            {
              symbol: 11,
              multiplier: 0,
            },
          ],
          [
            {
              symbol: 10,
              multiplier: 0,
            },
            {
              symbol: 8,
              multiplier: 0,
            },
            {
              symbol: 2,
              multiplier: 100,
            },
            {
              symbol: 9,
              multiplier: 0,
            },
            {
              symbol: 7,
              multiplier: 0,
            },
          ],
          [
            {
              symbol: 3,
              multiplier: 0,
            },
            {
              symbol: 6,
              multiplier: 0,
            },
            {
              symbol: 3,
              multiplier: 0,
            },
            {
              symbol: 4,
              multiplier: 0,
            },
            {
              symbol: 3,
              multiplier: 0,
            },
          ],
          [
            {
              symbol: 1,
              multiplier: 0,
            },
            {
              symbol: 9,
              multiplier: 0,
            },
            {
              symbol: 10,
              multiplier: 0,
            },
            {
              symbol: 8,
              multiplier: 0,
            },
            {
              symbol: 10,
              multiplier: 0,
            },
          ],
        ],
      },
      returnCode: 0,
      message: '',
      slotVoucherSummary: {
        voucherId: '32011jdoijd11322',
        amount: 5,
        fixedStake: 1,
        expireDate: '2027-01-01T00:00:00',
        freeSpin: 5,
        usedFreeSpin: 0,
        netFreeSpin: 3,
      },
    }
  },
}
